import { render, staticRenderFns } from "./complaintList.vue?vue&type=template&id=5c846ab6&scoped=true&"
import script from "./complaintList.vue?vue&type=script&lang=js&"
export * from "./complaintList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c846ab6",
  null
  
)

export default component.exports